import {
  Flex, Grid, GridItem, Icon, IconButton, Text,
} from "@chakra-ui/react";
import { FcFolder } from "react-icons/fc";
import Helper from "../../../utils/Helper";

export default function Folder({ Item, OnChange, OnSelect, texts = {} }) { 
  const fileManagerTexts = texts?.fileManager || {};
  
  return (
    <Grid 
      templateColumns={"repeat(12, 1fr)"} 
      gap={2}
      alignItems="center" 
      w="100%" 
      py={2}
      borderRadius="md" 
      cursor="pointer"
      onDoubleClick={() => OnSelect(Item)}
      sx={{
        _hover: { 
          bg: 'var(--fm-item-hover-bg)' 
        }
      }}
    >
      <GridItem colSpan={{ base: 12, md: 5 }} as={Flex} alignItems="center">
        <Icon as={FcFolder} boxSize="1.5rem" mr={3} />
        <Text noOfLines={1} fontSize="sm">{Item.FolderName}</Text>
      </GridItem>
      
      <GridItem colSpan={2} textAlign="center" display={{ base: 'none', md: 'block' }}>
        <Text fontSize="xs" sx={{ color: 'var(--fm-item-meta-text)' }}>-</Text>
      </GridItem>
      
      <GridItem colSpan={2} textAlign="center" display={{ base: 'none', md: 'block' }}>
        <Text fontSize="xs" sx={{ color: 'var(--fm-item-meta-text)' }}>
          {Helper.HandleChatDate(Item.FolderUpdatedAt || Item.FolderCreatedAt)}
        </Text>
      </GridItem>


    </Grid>
  );
}